import * as FetchJSONHelper from '../../helpers/FetchJSONHelper'
import JSONFilesEnum from '../../enums/JSONFilesEnum';
import { HomePageProps, HomePageState } from './HomePage';

export class HomePageController {
    public setState = (() => { }) as (partialState: any) => void
    public getState = (): HomePageState => { return {} as any }

    private props: HomePageProps = {}

    /* Base controller configuration */

    config = (setState: (partialState: any, overwrite?: boolean) => void, getState: () => HomePageState, getDefaultState: () => HomePageState, props: HomePageProps) => {
        this.setState = setState
        this.getState = getState
        this.props = props
    }

    /* Initializers */

    initialize = () => {
        this.initializeWorkers();
    }

    initializeWorkers = () => {
        this.getWorkersBackend((usersJson: any) => {
            this.setState({ workerResponse: usersJson.workers })
        }, (e: Response) => {
            console.log("usersJson errors ==>", e)
        })
    }

    /* Backend JSON Files calls */

    private getWorkersBackend = (success?: (users: any) => void, error?: (e: Response) => void) => {
        FetchJSONHelper.callJSONFiles(JSONFilesEnum.WORKERS_JSON, 'GET', success, error);
    }
}